import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface } from '@src/components/pl-base-widget'

import { BundlePurchaseWidgetComponent } from './bundle-purchase-widget.component'

import type { BundlePurchaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * BUNDLE_PURCHASE widget — the PL bundle buy box (emitted by the BE instead of PRODUCT_PURCHASE).
 * Reuses the legacy `BundleProductPurchase` via the proto -> Bundle adapter.
 */
export const BundlePurchaseWidget: PLTypedWidgetInterface<BundlePurchaseWidgetData, WidgetType.BUNDLE_PURCHASE> = {
  id: WidgetType.BUNDLE_PURCHASE,
  errorBoundary: PLBaseErrorBoundary,
  render: BundlePurchaseWidgetComponent,
}
